document.addEventListener("DOMContentLoaded", function () {
	// TODO use luxon in edit mode https://moment.github.io/luxon/#/zones
	/** hide past events */
	const filterDate = new Date();
	filterDate.setUTCDate(filterDate.getUTCDate() - 3);
	filterDate.setUTCHours(0, 0, 0, 0);

	document.querySelectorAll("table.wp-block-lkg-gotha-termine-element td time").forEach(function (time) {
		const event = new Date(time.getAttribute("datetime"));
		event.setUTCHours(0, 0, 0, 0);
		if (event < filterDate) time.closest("tr").style.display = "none";
	});
});